import React from 'react'

export default function FaceBookLink(props) {
  return (
    // <svg
    //   width={props.width ? props.width : 16}
    //   height={props.height ? props.height : 16}
    //   viewBox='0 0 16 16'
    //   fill='none'
    //   xmlns='http://www.w3.org/2000/svg'
    // >
    //   <path
    //     fillRule='evenodd'
    //     clipRule='evenodd'
    //     d='M7.9987 13.334C10.9442 13.334 13.332 10.9462 13.332 8.00065C13.332 5.05513 10.9442 2.66732 7.9987 2.66732C5.05318 2.66732 2.66536 5.05513 2.66536 8.00065C2.66536 10.9462 5.05318 13.334 7.9987 13.334ZM7.9987 14.6673C11.6806 14.6673 14.6654 11.6825 14.6654 8.00065C14.6654 4.31875 11.6806 1.33398 7.9987 1.33398C4.3168 1.33398 1.33203 4.31875 1.33203 8.00065C1.33203 11.6825 4.3168 14.6673 7.9987 14.6673Z'
    //     fill={props.color ? props.color : '#97A3C7'}
    //   />
    //   <path
    //     d='M7.9987 6.66602C7.9987 6.29783 8.29717 5.99935 8.66536 5.99935H9.33203C9.70022 5.99935 9.9987 5.70087 9.9987 5.33268C9.9987 4.96449 9.70022 4.66602 9.33203 4.66602H8.66536C7.56079 4.66602 6.66536 5.56145 6.66536 6.66602V7.99935H5.9987C5.63051 7.99935 5.33203 8.29783 5.33203 8.66602C5.33203 9.03421 5.63051 9.33268 5.9987 9.33268H6.66536V13.3327C6.66536 13.7009 6.96384 13.9993 7.33203 13.9993C7.70022 13.9993 7.9987 13.7009 7.9987 13.3327V9.33268H9.33203C9.70022 9.33268 9.9987 9.03421 9.9987 8.66602C9.9987 8.29783 9.70022 7.99935 9.33203 7.99935H7.9987V6.66602Z'
    //     fill={props.color ? props.color : '#97A3C7'}
    //   />
    // </svg>

    <svg
      width={props.width ? props.width : 24}
      height={props.height ? props.height : 24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        fill={props.color ? props.color : '#97A3C7'}
      />
      <path
        d='M12 10C12 9.44772 12.4477 9 13 9H14C14.5523 9 15 8.55229 15 8C15 7.44772 14.5523 7 14 7H13C11.3431 7 10 8.34315 10 10V12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14H10V20C10 20.5523 10.4477 21 11 21C11.5523 21 12 20.5523 12 20V14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H12V10Z'
        fill={props.color ? props.color : '#97A3C7'}
      />
    </svg>
  )
}
